module.exports = __webpack_public_path__ + "static/media/abhiram.52a7fe1a.jpg";